import { useApi } from 'api/api-context';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { LOGIN_PAGE_PATH, LOGOUT_PAGE_PATH, PASSWORD_CHANGE_REQUIRED_PAGE_PATH } from 'routes/paths';

/**
 * Require auth component.
 */
export default function RequireAuth({ redirect = LOGIN_PAGE_PATH.original }: { redirect?: string }) {
  const { jwt, passwordChangeRequired } = useApi();
  const location = useLocation();

  if (!jwt) {
    const returnUrl = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`${redirect}?returnUrl=${returnUrl}`} replace />;
  }

  if (
    passwordChangeRequired &&
    location.pathname !== PASSWORD_CHANGE_REQUIRED_PAGE_PATH.original &&
    location.pathname !== LOGOUT_PAGE_PATH.original
  ) {
    const returnUrl = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`${PASSWORD_CHANGE_REQUIRED_PAGE_PATH.original}?returnUrl=${returnUrl}`} replace />;
  }

  return <Outlet />;
}
